import { useEffect, useState } from "react";
import reorder, { reorderQuoteMap } from "../reorder";
import { DragDropContext, DropResult, Droppable } from "react-beautiful-dnd";
import Column from "./Column";
import '../styles/style.css';
import { UserTask } from "app/models/user-task";

interface BoardProps {
  isCombineEnabled?: boolean;
  initial: Record<string, any>;
  useClone: boolean;
  containerHeight?: number;
  withScrollableColumns: boolean;
}

const Board: React.FC<BoardProps> = ({
  isCombineEnabled = false,
  initial,
  useClone,
  containerHeight,
  withScrollableColumns,
}) => {
  const [columns, setColumns] = useState(initial);
  const [ordered, setOrdered] = useState<any[]>(Object.keys(initial));
  // const initData = initial;
  // const [data, setData] = useState(initData);
  // console.log("InitData: ", Object.keys(initial));
  // console.log("Columns: ", columns);
  // console.log("Ordered: ", ordered);
  useEffect(() => {
    setOrdered(Object.keys(initial));
    setColumns(initial);
  }, [initial]);

  const onDragEnd = (result: DropResult) => {
    console.log("UserTaskMap: ", columns);
    if (result.combine) {
      if (result.type === "COLUMN") {
        const shallow = [...ordered];
        shallow.splice(result.source.index, 1);
        setOrdered(shallow);
        return;
      }

      const column = columns[result.source.droppableId];
      const withQuoteRemoved = [...column];

      withQuoteRemoved.splice(result.source.index, 1);

      const orderedColumns = {
        ...columns,
        [result.source.droppableId]: withQuoteRemoved,
      };
      setColumns(orderedColumns);
      return;
    }

    if (!result.destination) {
      return;
    }

    const source = result.source;
    const destination = result.destination;

    // did not move anywhere - can bail early
    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      return;
    }

    if (result.type === "COLUMN") {
      const reorderedorder = reorder(ordered, source.index, destination.index);

      setOrdered(reorderedorder);

      return;
    }

    const data = reorderQuoteMap({
      quoteMap: columns,
      source,
      destination,
    });

    setColumns(data.quoteMap);
  };

  return (
    <>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable
          droppableId="board"
          type="COLUMN"
          direction="horizontal"
          ignoreContainerClipping={Boolean(containerHeight)}
          isCombineEnabled={isCombineEnabled}
        >
          {(provided) => (
            <div className="container-board" ref={provided.innerRef} {...provided.droppableProps}>
              {ordered.map((key, index) => (
                <Column
                  key={key}
                  index={index}
                  title={key}
                  quotes={columns[key]}
                  isScrollable={withScrollableColumns}
                  isCombineEnabled={isCombineEnabled}
                  useClone={useClone}
                />
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );
};

export default Board;